import {ARROW_DIRECTION_LABELS, type ArrowDirection} from '../../../lib/lvs-arrow'
import type {CustomStepProps} from '../../../lib/sign-catalog'
import {MonoLabel} from '../../ui/mono-label'
import {UnderlineSelect} from '../../ui/underline-field'
import {lvsRef} from '../../../lib/utils'

const DIRECTIONS: readonly ArrowDirection[] = ['left', 'right']

export function ArrowStep({input, onChange}: CustomStepProps) {
    const value: ArrowDirection = input.arrowDirection ?? 'left'

    return (
        <section className='space-y-5 max-w-md'>
            <div className='flex flex-col gap-1.5'>
                <MonoLabel>Bultas virziens ({lvsRef('9.26', 'clause')})</MonoLabel>
                <UnderlineSelect
                    value={value}
                    onChange={e => onChange({arrowDirection: e.target.value as ArrowDirection})}
                >
                    {DIRECTIONS.map(d => (
                        <option
                            key={d}
                            value={d}
                        >
                            {ARROW_DIRECTION_LABELS[d]}
                        </option>
                    ))}
                </UnderlineSelect>
            </div>
        </section>
    )
}
